import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
import CRMLayout from "./layouts/CRMLayout";
import PortalLayout from "./layouts/PortalLayout";
import StartLayout from "./layouts/StartLayout";
import Sidebar from "./components/Sidebar";
import PortalSidebar from "./components/PortalSidebar";
import StartSidebar from "./components/StartSidebar";
import MainContent from "./components/MainContent";
import ProtectedRoute from "./components/ProtectedRoute";
import RoleBasedRoute from "./components/RoleBasedRoute";
import PortalAccessGuard from "./components/PortalAccessGuard";
import SmartRedirect from "./components/SmartRedirect";
import AuthErrorBoundary from "./components/AuthErrorBoundary";
import AuthLoadingIndicator from "./components/AuthLoadingIndicator";
import AnalyticsTracker from "./components/AnalyticsTracker";

import WelcomeJTBootcamp from "./pages/welcome/JTBootcamp";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import Dashboard from "./pages/Dashboard";
import StartDashboard from "./pages/StartDashboard";
import StartAssessment from "./pages/StartAssessment";
import StartCommunity from "./pages/StartCommunity";
import StartSales from "./pages/StartSales";
import StartTechnology from "./pages/StartTechnology";
import StartFinance from "./pages/StartFinance";
import StartMarketing from "./pages/StartMarketing";
import StartHR from "./pages/StartHR";
import StartCourses from "./pages/StartCourses";
import StartOperations from "./pages/StartOperations";
import StartProfile from "./pages/StartProfile";
import StartHourly from "./pages/StartHourly";
import StartRoadmap from "./pages/StartRoadmap";
import StartLaborBurden from "./pages/StartLaborBurden";
import StartMeetTheTeam from "./pages/StartMeetTheTeam";
import StartSuccessStories from "./pages/StartSuccessStories";
import StartCQCHome from "./pages/StartCQCHome";
import StartProcess from "./pages/StartProcess";
import StartBreakthroughSession from "./pages/StartBreakthroughSession";
import Tasks from "./pages/Tasks";
import Calendar from "./pages/Calendar";
import PortalCalendar from "./pages/PortalCalendar";
import Contacts from "./pages/Contacts";
import Accounts from "./pages/Accounts";
import ClientPurchases from "./pages/ClientPurchases";
import Goals from "./pages/Goals";
import AssessmentTemplate from "./pages/crm/AssessmentTemplate";
import ClientPortalView from "./pages/ClientPortalView";
import Templates from "./pages/Templates";
import Catalog from "./pages/Catalog";
import TimeTracking from "./pages/TimeTracking";
import Expenses from "./pages/Expenses";
import Reports from "./pages/Reports";
import MarketingReports from "./pages/MarketingReports";
import SalesReports from "./pages/SalesReports";
import MeetingsReports from "./pages/crm/meetings-reports";
import CompanyGoals from "./pages/CompanyGoals";
import ClientSatisfaction from "./pages/ClientSatisfaction";
import FinanceReports from "./pages/FinanceReports";
import CallReports from "./pages/CallReports";
import ConferencesReports from "./pages/ConferencesReports";
import ConferenceOverview from "./pages/ConferenceOverview";
import ConferenceSpinwheel from "./pages/ConferenceSpinwheel";
import BreakthroughsReports from "./pages/BreakthroughsReports";
import LostLeadsReports from "./pages/LostLeadsReports";
import LostClientsReports from "./pages/LostClientsReports";
import ActivityFeed from "./pages/ActivityFeed";
import MyProfile from "./pages/MyProfile";
import CRMProfile from './pages/crm/CRMProfile';
import InternalUsers from "./pages/InternalUsers";
import Settings from "./pages/Settings";

import IntegrationCallback from "./components/IntegrationCallback";
import UserIntegrationCallback from "./components/UserIntegrationCallback";
import CourseDashboard from "./pages/CourseDashboard";
import ClientDashboard from './pages/ClientDashboard';
import PortalKickoff from './pages/PortalKickoff';
import TakeoffProjects from './pages/TakeoffProjects';
import Automation from './pages/Automation';
import CourseTopicPage from './pages/PDPMModel';
import SubModel from './pages/SubModel';
import MissionVisionValuesCourse from './pages/MissionVisionValues';
import MyMissionVisionValues from './pages/MyMissionVisionValues';
import ExistingDirection from './pages/ExistingDirection';
import CompanyDirection from './pages/CompanyDirection';
import JobDescriptions from './pages/JobDescriptions';
import BusinessLaunchBlueprint from './pages/BusinessLaunchBlueprint';
import LeadFlowMastery from './pages/LeadFlowMastery';
import SalesAccelerator from './pages/SalesAccelerator';
import UltimateDesign from './pages/UltimateDesign';
import BuildExecution from './pages/BuildExecution';
import SalesDomination from './pages/SalesDomination';
import OperationalExcellence from './pages/OperationalExcellence';
import TechAutomation from './pages/TechAutomation';
import FinancialMastery from './pages/FinancialMastery';
import MarketingWorks from './pages/MarketingWorks';
import HRHiring from './pages/HRHiring';
import Onboarding from './pages/Onboarding';
import CompanyPolicy from './pages/CompanyPolicy';
import ScalingRoadmap from './pages/ScalingRoadmap';
import HiringLeadership from './pages/HiringLeadership';
import TechStackVisualizer from './pages/TechStack';
import NDASigningPage from './pages/NDA';
import NdaSigningReturn from './pages/NdaSigningReturn';
import ContractSigningReturn from './pages/ContractSigningReturn';
import BidContractSigningReturn from './pages/BidContractSigningReturn';
import OrgChart from './pages/OrgChart';
import ExistingOrgChart from './pages/ExistingOrgChart';
import Collection from './pages/Collection';
import ProposedOrgChart from './pages/ProposedOrgChart';
import Finance from './pages/Finance';
import FinanceAllTab from './components/finance/FinanceAllTab';
import FinanceAnalyticsTab from './components/finance/FinanceAnalyticsTab';
import FinanceMaterialsTab from './components/finance/FinanceMaterialsTab';
import FinanceGoalsTab from './components/finance/FinanceGoalsTab';
import LaborBurdenCalculator from './pages/LaborBurden';
import MarginCalculator from './pages/MarginCalculator';
import OverheadCalculator from './pages/OverheadCalculator';
import Technology from './pages/technology';
import TechnologyGoalsTab from './components/technology/TechnologyGoalsTab';
import TechnologyAllTab from './components/technology/TechnologyAllTab';
import JobTreadImports from './pages/JobTreadImports';
import Receptionist from './pages/Receptionist';
import Chatbot from './pages/Chatbot';
import EstimatingTemplate from './pages/EstimatingTemplate';
import WebsiteCalculators from './pages/WebsiteCalculators';
import Marketing from './pages/Marketing';
import MarketingAllTab from './components/marketing/MarketingAllTab';
import MarketingAnalyticsTab from './components/marketing/MarketingAnalyticsTab';
import MarketingGoalsTab from './components/marketing/MarketingGoalsTab';
import Website from './pages/Website';
import LeadROI from './pages/LeadROI';
import LeadsCalculator from './pages/LeadsCalculator';
import ReviewsDashboard from './pages/Reviews';
import Strategy from './pages/Strategy';
import BillingPage from './pages/Billing';
import ClientBilling from './pages/ClientBilling';
import JobTreadFormulas from './pages/JobTreadFormulas';
import CostGroups from './pages/CostGroups';
import Schedules from './pages/Schedules';
import Dashboards from './pages/Dashboards';
import Todos from './pages/Todos';
import Workflows from './pages/Workflows';
import ClaudeSkills from './pages/ClaudeSkills';
import Agents from './pages/Agents';
import Roadmap from './pages/Roadmap';
import Community from './pages/Community';
import Fulfillment from './pages/crm/Fulfillment';
import GeneralFulfillment from './pages/crm/GeneralFulfillment';
import HRFulfillment from './pages/crm/HRFulfillment';
import PositionRequestOverview from './pages/crm/PositionRequestOverview';
import MarketingFulfillment from './pages/crm/MarketingFulfillment';
import MarketingFulfillmentWebsiteClient from './pages/crm/MarketingFulfillmentWebsiteClient';
import MarketingFulfillmentSocialClient from './pages/crm/MarketingFulfillmentSocialClient';
import MarketingFulfillmentAdsClient from './pages/crm/MarketingFulfillmentAdsClient';
import MarketingFulfillmentNewsletterClient from './pages/crm/MarketingFulfillmentNewsletterClient';
import MarketingFulfillmentReviewsClient from './pages/crm/MarketingFulfillmentReviewsClient';
import BreakthroughsFulfillment from './pages/crm/BreakthroughsFulfillment';
import BreakthroughSessionsArchive from './pages/crm/BreakthroughSessionsArchive';
import ClientRoadmaps from './pages/crm/ClientRoadmaps';
import ClientRoadmapOverview from './pages/crm/ClientRoadmapOverview';
import FulfillmentKickoff from './pages/crm/FulfillmentKickoff';
import KickoffOverview from './pages/crm/KickoffOverview';
import PluginsFulfillment from './pages/crm/PluginsFulfillment';
import BrandingTemplate from './pages/crm/BrandingTemplate';
import PluginDetail from './pages/crm/PluginDetail';
import Partners from './pages/crm/Partners';
import CRMAgents from './pages/crm/CRMAgents';
import StaffActivity from './pages/crm/StaffActivity';
import PartnerOverview from './pages/crm/PartnerOverview';
import PortalView from './pages/crm/PortalView';
import PortalTasks from './pages/PortalTasks';
import PortalConference from './pages/PortalConference';
import Messages from './pages/Messages';
import CRMtechstack from './pages/portal/CRMtechstack';
import PhoneCalls from './components/PhoneCalls';
import CRMMarketing from './pages/crm/Marketing';


import PortalSales from './pages/PortalSales';
import SalesAllTab from './components/sales/SalesAllTab';
import SalesAnalyticsTab from './components/sales/SalesAnalyticsTab';
import SalesGoalsTab from './components/sales/SalesGoalsTab';
import SalesResourcesTab from './components/sales/SalesResourcesTab';
import PortalOperations from './pages/PortalOperations';
import OperationsAllTab from './components/operations/OperationsAllTab';
import OperationsMaterialsTab from './components/operations/OperationsMaterialsTab';
import PortalJobTread from './pages/PortalJobTread';
import GPMOperations from './pages/GPMOperations';
import PortalHR from './pages/PortalHR';
import HRAllTab from './components/hr/HRAllTab';
import HRMaterialsTab from './components/hr/HRMaterialsTab';
import { HRIndexRedirect } from './components/hr/HRTabNav';
import PortalKPIs from './pages/PortalKPIs';
import RoadmapBuilder from './pages/RoadmapBuilder';
import Solutions from './pages/Solutions';
import ProgramDetail, { CUSTOM_PROGRAM, CUSTOM_TIER } from './pages/ProgramDetail';
import ProgramCall from './pages/ProgramCall';
import Checkout from './pages/Checkout';
import CheckoutReturn from './pages/CheckoutReturn';
import StrategyCallCheckoutReturn from './pages/StrategyCallCheckoutReturn';
import Contract from './pages/Contract';
import PortalContract from './pages/PortalContract';
import ExistingConditions from './pages/ExistingConditions';
import ClientSteps from './pages/ClientSteps';
import SOPs from './pages/SOPs';
import SOPTemplates from './pages/SOPTemplates';
import Hiring from './pages/Hiring';
import JobListings from './pages/JobListings';
import InterviewEvaluation from './pages/InterviewEvaluation';

import EmployeeMaterials from './pages/EmployeeMaterials';
import PortalSalesProposals from './pages/PortalSalesProposals';
import StartCloseRatio from './pages/StartCloseRatio';
import StartProposals from './pages/StartProposals';
import StartSalesMaterials from './pages/StartSalesMaterials';
import StartSOPs from './pages/StartSOPs';
import StartKPIs from './pages/StartKPIs';
import StartJobDescriptions from './pages/StartJobDescriptions';
import StartPartnerPrograms from './pages/StartPartnerPrograms';
import StartEstimatingTemplate from './pages/StartEstimatingTemplate';
import StartGPTs from './pages/StartGPTs';
import StartTechStack from './pages/StartTechStack';
import DesignPricing from './pages/DesignPricing';
import BuildPaymentCalculator from './pages/BuildPaymentCalculator';
import SalesRevenue from './pages/SalesRevenue';
import ClientOverview from './pages/ClientOverview';
import ClientLeadHistory from './pages/ClientLeadHistory';
import LeadOverview from './pages/LeadOverview';
import AssessmentAnalysis from './pages/AssessmentAnalysis';
import AssessmentAnalysisOverview from './pages/AssessmentAnalysisOverview';
import ProposalAnalysis from './pages/ProposalAnalysis';
import CompanyMeetingHistory from './pages/CompanyMeetingHistory';
import MeetingMode from './pages/MeetingMode';
import TechnologyReports from './pages/TechnologyReports';
import ClaudeSkillsTemplate from './pages/crm/ClaudeSkillsTemplate';
import AgentTemplates from './pages/crm/AgentTemplates';
import AgentTemplateOverview from './pages/crm/AgentTemplateOverview';
import LeadPortalReports from './pages/LeadPortalReports';
import { AuthProvider } from './contexts/AuthContext';
import { OnboardingProvider } from './contexts/OnboardingContext';
import { SummitProvider } from './contexts/SummitContext';
import { SidebarProvider } from './contexts/SidebarContext';
import { ResponsiveProvider } from './contexts/ResponsiveContext';
import { SurveyProvider, useSurvey } from './contexts/SurveyContext';
import CourseTemplates from './pages/CourseTemplates';
import CourseOverview from './pages/CourseOverview';
import LessonOverview from './pages/LessonOverview';
import AutomationTemplates from './pages/AutomationTemplates';
import AutomationOverview from './pages/AutomationOverview';
import AutomationTemplateOverview from './pages/AutomationTemplateOverview';
import TechStackTemplate from './pages/TechStackTemplate';


import AllSoftware from './pages/AllSoftware';
import SoftwareOverview from './pages/SoftwareOverview';
import ModuleOverview from './pages/ModuleOverview';
import CourseContent from './pages/CourseContent';
import KPITemplates from './pages/crm/KPITemplates';
import { ThemeProvider } from './contexts/ThemeContext';
import HRCollections from './pages/crm/HRCollections';
import MyDocuments from './pages/crm/MyDocuments';
import SalesCollections from './pages/crm/SalesCollections';
import FinanceCollections from './pages/crm/FinanceCollections';
import OperationsCollections from './pages/crm/OperationsCollections';
import CrmCollection from './pages/crm/CrmCollection';
import RoadmapTemplates from './pages/crm/roadmap-templates';
import RoadmapTemplateOverview from './pages/crm/RoadmapTemplateOverview';
import Packages from './pages/packages';
import JobDescriptionTemplates from './pages/JobDescriptionTemplates';
import ProgramsTemplate from './pages/crm/programs-template';
import RoutingTemplate from './pages/crm/routing-template';
import TemplatesImports from './pages/crm/templates/Imports';
import MarketingAccessTemplates from './pages/crm/MarketingAccessTemplates';
import DripCampaigns from './pages/crm/DripCampaigns';
import AlaCarteTemplate from './pages/crm/alacartetemplate';
import AlaCarteItemOverview from './pages/crm/AlaCarteItemOverview';
import AlaCarteBidOverview from './pages/crm/AlaCarteBidOverview';
import AlaCarteBidsBoard from './pages/crm/AlaCarteBidsBoard';
import TeamAlaCarteQueue from './pages/crm/TeamAlaCarteQueue';
import TeamAlaCarteCatalog from './pages/crm/TeamAlaCarteCatalog';
import TeamAlaCarteItemWorkspace from './pages/crm/TeamAlaCarteItemWorkspace';
import CrmTeamAlaCarteRoute from './components/CrmTeamAlaCarteRoute';
import AlaCarte from './pages/portal/AlaCarte';
import QuestionsPage from './pages/Questions';
import QuestionDetail from './pages/QuestionDetail';
import NewQuestion from './pages/NewQuestion';
import MyQuestionsPage from './pages/MyQuestions';
import PortalQuestionDetail from './pages/PortalQuestionDetail';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import OnboardingWrapper from './components/OnboardingWrapper';
import BBASummit from './pages/BBASummit';
import SummitOverview from './pages/SummitOverview';
import SurveyPopup from './components/SurveyPopup';
import BookOnSite from './pages/bookonsite';
import BookCQC from './pages/bookcqc';
import PositionHiringOverview from './pages/PositionHiringOverview';
import Discovery from './pages/Discovery';
import { CRM_OWNER_EXECUTIVE_ROLES } from './services/accessControlService';
import ReportAccessGate from './components/crm/ReportAccessGate';

function CrmOwnerExecutiveRoute({ children, internalDeniedRedirect = '/crm' }) {
  return (
    <RoleBasedRoute
      allowedUserTypes={['internal']}
      allowedRoles={CRM_OWNER_EXECUTIVE_ROLES}
      internalDeniedRedirect={internalDeniedRedirect}
    >
      {children}
    </RoleBasedRoute>
  );
}

// CRM ▸ Reports pages: Owners/Executives plus whoever the report's access list names
// (reportAccess/{reportId}, see utils/reportCatalog.js)
function CrmReportRoute({ reportId, children }) {
  return (
    <RoleBasedRoute allowedUserTypes={['internal']}>
      <ReportAccessGate reportId={reportId}>
        {children}
      </ReportAccessGate>
    </RoleBasedRoute>
  );
}

// Survey Popup Wrapper Component
const SurveyPopupWrapper = () => {
  const { showSurveyPopup, closeSurveyPopup, surveyId } = useSurvey();
  
  return (
    <SurveyPopup
      isOpen={showSurveyPopup}
      onClose={closeSurveyPopup}
      surveyId={surveyId}
    />
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AuthLoadingIndicator />
        <ResponsiveProvider>
          <OnboardingProvider>
            <SurveyProvider>
              <Router>
              <AnalyticsTracker />
              <AuthErrorBoundary>
              <Routes>
              {/* Public routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/terms" element={<TermsOfUse />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/internal-users" element={<Navigate to="/crm/internal-users" replace />} />
              <Route path="/packages" element={<Packages />} />
              <Route path="/welcome/JTBootcamp" element={<WelcomeJTBootcamp />} />

              {/* OAuth Callback Routes */}
              <Route path="/auth/google/callback" element={<IntegrationCallback />} />
              <Route path="/auth/user/google/callback" element={<UserIntegrationCallback />} />

              <Route path="/auth/twilio/callback" element={<IntegrationCallback />} />
              <Route path="/auth/stripe/callback" element={<IntegrationCallback />} />
              <Route path="/auth/quickbooks/callback" element={<IntegrationCallback />} />
              <Route path="/auth/zapier/callback" element={<IntegrationCallback />} />
              <Route path="/auth/meta/callback" element={<IntegrationCallback />} />
              <Route path="/auth/docusign/callback" element={<IntegrationCallback />} />
              <Route path="/auth/activecampaign/callback" element={<IntegrationCallback />} />
              <Route path="/auth/calendly/callback" element={<UserIntegrationCallback />} />
              <Route path="/auth/fathom/callback" element={<UserIntegrationCallback />} />

              {/* Root route - smart redirect based on auth and role */}
              <Route path="/" element={
                process.env.NODE_ENV === 'development' ? (
                  <Navigate to="/start" replace />
                ) : (
                  <SmartRedirect />
                )
              } />

              {/* Protected routes */}
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Navigate to="/crm" replace />
                </ProtectedRoute>
              } />

              {/* CRM Routes - Internal Users Only (auth enforced in dev and prod) */}
              <Route path="/crm" element={
                <RoleBasedRoute allowedUserTypes={['internal']}>
                  <SidebarProvider>
                    <div className="app-container">
                      <Sidebar />
                      <MainContent>
                        <div className="page-content">
                          <CRMLayout />
                        </div>
                      </MainContent>
                    </div>
                  </SidebarProvider>
                </RoleBasedRoute>
              }>
                <Route index element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />

                <Route path="calendar" element={<Calendar />} />
                <Route path="contacts" element={
                  <CrmOwnerExecutiveRoute internalDeniedRedirect="/crm/clients">
                    <Contacts />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="accounts" element={
                  <CrmOwnerExecutiveRoute internalDeniedRedirect="/crm/clients">
                    <Accounts />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="leads" element={
                  <CrmOwnerExecutiveRoute internalDeniedRedirect="/crm/clients">
                    <Accounts />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="clients" element={<Accounts />} />
                <Route path="lead/:leadId" element={
                  <CrmOwnerExecutiveRoute internalDeniedRedirect="/crm/clients">
                    <LeadOverview />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="lead/:leadId/assessment-analysis" element={
                  <CrmOwnerExecutiveRoute internalDeniedRedirect="/crm/clients">
                    <AssessmentAnalysis />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="lead/:leadId/programdetail" element={
                  <CrmOwnerExecutiveRoute internalDeniedRedirect="/crm/clients">
                    <ProgramDetail />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="lead/:leadId/proposal-analysis" element={
                  <CrmOwnerExecutiveRoute internalDeniedRedirect="/crm/clients">
                    <ProposalAnalysis />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="client/:clientId" element={<ClientOverview />} />
                <Route path="client/:clientId/lead-history" element={<ClientLeadHistory />} />
                <Route path="collection" element={<CrmCollection />} />
                <Route path="tasks" element={<Tasks />} />
                <Route path="messages" element={<Messages />} />
                <Route path="calendar" element={<Calendar />} />
                <Route path="client-purchases" element={<CrmReportRoute reportId="client-purchases"><ClientPurchases /></CrmReportRoute>} />
                <Route path="company-goals" element={<CrmReportRoute reportId="goals"><CompanyGoals /></CrmReportRoute>} />
                <Route path="client-satisfaction" element={<CrmReportRoute reportId="client-satisfaction"><ClientSatisfaction /></CrmReportRoute>} />
                <Route path="templates" element={
                  <CrmOwnerExecutiveRoute>
                    <Templates />
                  </CrmOwnerExecutiveRoute>
                } />
                {/* Technology templates are managed from the Technology department page (open to the tech team, not just Owner/Executive) */}
                <Route path="templates/imports" element={<TemplatesImports />} />
                <Route path="templates/plugins" element={<PluginsFulfillment />} />
                {/* BBA brand kit — Owner only (the page redirects everyone else) */}
                <Route path="templates/branding" element={<BrandingTemplate />} />
                <Route path="claude-skills-template" element={<ClaudeSkillsTemplate />} />
                <Route path="agent-templates" element={<AgentTemplates />} />
                <Route path="agent-templates/:agentId" element={<AgentTemplateOverview />} />
                <Route path="course-templates" element={
                  <CrmOwnerExecutiveRoute>
                    <CourseTemplates />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="course-templates/:courseId" element={
                  <CrmOwnerExecutiveRoute>
                    <CourseOverview />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="course-templates/:courseId/modules/:moduleId" element={
                  <CrmOwnerExecutiveRoute>
                    <ModuleOverview />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="course-templates/:courseId/lessons/:lessonId" element={
                  <CrmOwnerExecutiveRoute>
                    <LessonOverview />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="catalog" element={<Catalog />} />
                <Route path="time-tracking" element={<TimeTracking />} />
                <Route path="reports" element={
                  <RoleBasedRoute allowedUserTypes={['internal']}>
                    <Reports />
                  </RoleBasedRoute>
                } />
                <Route path="marketing-reports" element={
                  <CrmReportRoute reportId="marketing">
                    <MarketingReports />
                  </CrmReportRoute>
                } />
                <Route path="sales-reports" element={
                  <CrmReportRoute reportId="sales">
                    <SalesReports />
                  </CrmReportRoute>
                } />
                <Route path="lost-leads-reports" element={
                  <CrmReportRoute reportId="lost-leads">
                    <LostLeadsReports />
                  </CrmReportRoute>
                } />
                <Route path="lost-clients-reports" element={
                  <CrmReportRoute reportId="lost-clients">
                    <LostClientsReports />
                  </CrmReportRoute>
                } />
                <Route path="meetings-reports" element={
                  <CrmReportRoute reportId="meetings">
                    <MeetingsReports />
                  </CrmReportRoute>
                } />
                <Route path="meeting-mode" element={
                  <CrmOwnerExecutiveRoute>
                    <MeetingMode />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="technology-reports" element={
                  <CrmReportRoute reportId="technology">
                    <TechnologyReports />
                  </CrmReportRoute>
                } />
                <Route path="marketing" element={<CRMMarketing />} />
                <Route path="internal-users" element={<InternalUsers />} />
                <Route path="partners" element={
                  <CrmOwnerExecutiveRoute>
                    <Partners />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="agents" element={
                  <CrmOwnerExecutiveRoute>
                    <CRMAgents />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="staff-activity" element={
                  <CrmReportRoute reportId="staff-activity">
                    <StaffActivity />
                  </CrmReportRoute>
                } />
                <Route path="partners/:partnerId" element={
                  <CrmOwnerExecutiveRoute>
                    <PartnerOverview />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="settings" element={<Settings />} />
                <Route path="questions" element={<QuestionsPage />} />
                <Route path="questions/new" element={<NewQuestion />} />
                <Route path="questions/:questionId" element={<QuestionDetail />} />
                <Route path="my-profile" element={<CRMProfile />} />
                <Route path="activity-feed" element={<ActivityFeed />} />
                <Route path="finance-reports" element={
                  <CrmReportRoute reportId="finance">
                    <FinanceReports />
                  </CrmReportRoute>
                } />
                <Route path="call-reports" element={
                  <CrmReportRoute reportId="call-reports">
                    <CallReports />
                  </CrmReportRoute>
                } />
                <Route path="conferences-reports" element={
                  <CrmReportRoute reportId="conferences">
                    <ConferencesReports />
                  </CrmReportRoute>
                } />
                <Route path="conferences-reports/:conferenceId" element={
                  <CrmReportRoute reportId="conferences">
                    <ConferenceOverview />
                  </CrmReportRoute>
                } />
                <Route path="conferences-reports/:conferenceId/spinwheel" element={
                  <CrmReportRoute reportId="conferences">
                    <ConferenceSpinwheel />
                  </CrmReportRoute>
                } />
                <Route path="breakthroughs-reports" element={
                  <CrmReportRoute reportId="breakthroughs">
                    <BreakthroughsReports />
                  </CrmReportRoute>
                } />
                <Route path="lead-portal-reports" element={
                  <CrmReportRoute reportId="lead-portal">
                    <LeadPortalReports />
                  </CrmReportRoute>
                } />
                <Route path="expenses" element={<Expenses />} />
                <Route path="automation" element={<Automation />} />
                <Route path="community" element={<Community />} />
                <Route path="portalview/:accountId/:department/:tab/:content" element={<PortalView />} />
                <Route path="portalview/:accountId/:department/:tab" element={<PortalView />} />
                <Route path="portalview" element={<PortalView />} />
                <Route path="assessmenttemplate" element={
                  <CrmOwnerExecutiveRoute internalDeniedRedirect="/crm/clients">
                    <AssessmentTemplate />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="assessmenttemplate/:leadId" element={
                  <CrmOwnerExecutiveRoute internalDeniedRedirect="/crm/clients">
                    <AssessmentTemplate />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="fulfillment" element={<Fulfillment />} />
                <Route path="fulfillment/general" element={<GeneralFulfillment />} />
                <Route path="fulfillment/hr" element={<HRFulfillment />} />
                <Route path="fulfillment/hr/request/:requestId" element={<PositionRequestOverview />} />
                <Route path="fulfillment/marketing" element={<MarketingFulfillment />} />
                <Route path="fulfillment/marketing/website/:clientId" element={<MarketingFulfillmentWebsiteClient />} />
                <Route path="fulfillment/marketing/social/:clientId" element={<MarketingFulfillmentSocialClient />} />
                <Route path="fulfillment/marketing/ads/:clientId" element={<MarketingFulfillmentAdsClient />} />
                <Route path="fulfillment/marketing/newsletter/:clientId" element={<MarketingFulfillmentNewsletterClient />} />
                <Route path="fulfillment/marketing/reviews/:clientId" element={<MarketingFulfillmentReviewsClient />} />
                <Route path="fulfillment/breakthroughsfufillment" element={<BreakthroughsFulfillment />} />
                <Route path="fulfillment/breakthroughsessionsarchive" element={<BreakthroughSessionsArchive />} />
                <Route path="fulfillment/clientroadmaps" element={<ClientRoadmaps />} />
                <Route path="fulfillment/clientroadmaps/:clientId" element={<ClientRoadmapOverview />} />
                <Route path="fulfillment/kickoff" element={<FulfillmentKickoff />} />
                <Route path="fulfillment/kickoff/:clientId" element={<KickoffOverview />} />
                <Route path="fulfillment/plugins" element={<Navigate to="/crm/templates/plugins" replace />} />
                <Route path="fulfillment/clientroadmaps/:clientId/template/:templateId" element={<RoadmapTemplateOverview />} />
                <Route path="fulfillment/plugin/:pluginId" element={<PluginDetail />} />
                <Route path="automation-templates" element={<AutomationTemplates />} />
                <Route path="automation-templates/:templateId" element={<AutomationTemplateOverview />} />
                <Route path="tech-stack-template" element={<TechStackTemplate />} />
                <Route path="awards-templates" element={<Navigate to="/crm/templates" replace />} />
                <Route path="hr-materials-template" element={<Navigate to="/crm/collection-hr" replace />} />
                <Route path="collection-hr" element={
                  <CrmTeamAlaCarteRoute team="HR">
                    <HRCollections />
                  </CrmTeamAlaCarteRoute>
                } />
                <Route path="my-documents" element={
                  <CrmTeamAlaCarteRoute team={['HR', 'Marketing']}>
                    <MyDocuments />
                  </CrmTeamAlaCarteRoute>
                } />
                <Route path="marketing-access-templates" element={
                  <CrmTeamAlaCarteRoute team="Marketing">
                    <MarketingAccessTemplates />
                  </CrmTeamAlaCarteRoute>
                } />
                <Route path="collection-sales" element={
                  <CrmOwnerExecutiveRoute>
                    <SalesCollections />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="collection-operations" element={
                  <CrmOwnerExecutiveRoute>
                    <OperationsCollections />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="collection-finance" element={
                  <CrmTeamAlaCarteRoute team="Finance">
                    <FinanceCollections />
                  </CrmTeamAlaCarteRoute>
                } />
                <Route path="roadmap-templates" element={
                  <CrmOwnerExecutiveRoute>
                    <RoadmapTemplates />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="roadmap-templates/:templateId" element={
                  <CrmOwnerExecutiveRoute>
                    <RoadmapTemplateOverview />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="software" element={<AllSoftware />} />
                <Route path="software/:softwareId" element={<SoftwareOverview />} />
                <Route path="kpi-templates" element={
                  <CrmOwnerExecutiveRoute>
                    <KPITemplates />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="sop-templates" element={
                  <CrmOwnerExecutiveRoute>
                    <SOPTemplates />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="job-description-templates" element={
                  <CrmOwnerExecutiveRoute>
                    <JobDescriptionTemplates />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="programs-template" element={
                  <CrmOwnerExecutiveRoute>
                    <ProgramsTemplate />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="routing-template" element={
                  <CrmOwnerExecutiveRoute>
                    <RoutingTemplate />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="drip-campaigns" element={
                  <CrmOwnerExecutiveRoute>
                    <DripCampaigns />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="alacartetemplate" element={
                  <CrmOwnerExecutiveRoute>
                    <AlaCarteTemplate />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="alacartetemplate/:itemId" element={
                  <CrmOwnerExecutiveRoute>
                    <AlaCarteItemOverview />
                  </CrmOwnerExecutiveRoute>
                } />
                {/* Gated in-page: execs or the bid's department team */}
                <Route path="alacarte-bid/:bidId" element={<AlaCarteBidOverview />} />
                <Route path="bids" element={
                  <CrmOwnerExecutiveRoute>
                    <AlaCarteBidsBoard />
                  </CrmOwnerExecutiveRoute>
                } />
                <Route path="marketing-alacarte-queue" element={
                  <CrmTeamAlaCarteRoute team="Marketing">
                    <TeamAlaCarteQueue department="Marketing" />
                  </CrmTeamAlaCarteRoute>
                } />
                <Route path="marketing-alacarte-queue/:itemId" element={
                  <CrmTeamAlaCarteRoute team="Marketing">
                    <TeamAlaCarteItemWorkspace department="Marketing" />
                  </CrmTeamAlaCarteRoute>
                } />
                <Route path="finance-alacarte-queue" element={
                  <CrmTeamAlaCarteRoute team="Finance">
                    <TeamAlaCarteQueue department="Finance" />
                  </CrmTeamAlaCarteRoute>
                } />
                <Route path="finance-alacarte-queue/:itemId" element={
                  <CrmTeamAlaCarteRoute team="Finance">
                    <TeamAlaCarteItemWorkspace department="Finance" />
                  </CrmTeamAlaCarteRoute>
                } />
                <Route path="hr-alacarte-queue" element={
                  <CrmTeamAlaCarteRoute team="HR">
                    <TeamAlaCarteQueue department="HR" />
                  </CrmTeamAlaCarteRoute>
                } />
                <Route path="hr-alacarte-queue/:itemId" element={
                  <CrmTeamAlaCarteRoute team="HR">
                    <TeamAlaCarteItemWorkspace department="HR" />
                  </CrmTeamAlaCarteRoute>
                } />
                <Route path="marketing-catalog" element={
                  <CrmTeamAlaCarteRoute team="Marketing">
                    <TeamAlaCarteCatalog department="Marketing" />
                  </CrmTeamAlaCarteRoute>
                } />
                <Route path="marketing-catalog/:itemId" element={
                  <CrmTeamAlaCarteRoute team="Marketing">
                    <TeamAlaCarteItemWorkspace department="Marketing" />
                  </CrmTeamAlaCarteRoute>
                } />
                <Route path="finance-catalog" element={
                  <CrmTeamAlaCarteRoute team="Finance">
                    <TeamAlaCarteCatalog department="Finance" />
                  </CrmTeamAlaCarteRoute>
                } />
                <Route path="finance-catalog/:itemId" element={
                  <CrmTeamAlaCarteRoute team="Finance">
                    <TeamAlaCarteItemWorkspace department="Finance" />
                  </CrmTeamAlaCarteRoute>
                } />
                <Route path="hr-catalog" element={
                  <CrmTeamAlaCarteRoute team="HR">
                    <TeamAlaCarteCatalog department="HR" />
                  </CrmTeamAlaCarteRoute>
                } />
                <Route path="hr-catalog/:itemId" element={
                  <CrmTeamAlaCarteRoute team="HR">
                    <TeamAlaCarteItemWorkspace department="HR" />
                  </CrmTeamAlaCarteRoute>
                } />
                <Route path="summit-overview" element={<CrmReportRoute reportId="summit"><SummitOverview /></CrmReportRoute>} />
                <Route path="clientbilling" element={
                  <CrmOwnerExecutiveRoute>
                    <ClientBilling />
                  </CrmOwnerExecutiveRoute>
                } />
              </Route>

              {/* Portal Routes - Portal Users Only (auth enforced in dev and prod) */}
              <Route path="/portal" element={
                <RoleBasedRoute allowedUserTypes={['portal']}>
                  <SummitProvider>
                    <SidebarProvider>
                      <div className="app-container">
                        <PortalSidebar />
                        <MainContent>
                          <div className="page-content">
                            <PortalLayout />
                          </div>
                        </MainContent>
                      </div>
                    </SidebarProvider>
                  </SummitProvider>
                </RoleBasedRoute>
              }>
                <Route index element={<ClientDashboard />} />
                <Route path="kickoff" element={<PortalAccessGuard><PortalKickoff /></PortalAccessGuard>} />
                <Route path="nda" element={<Navigate to="/start/nda" replace />} />
                <Route path="profile" element={<PortalAccessGuard><MyProfile /></PortalAccessGuard>} />
                <Route path="website-analytics" element={<Navigate to="/portal/marketing" replace />} />

                {/* Regular Portal Routes */}
                <Route path="tasks" element={<PortalAccessGuard><PortalTasks /></PortalAccessGuard>} />
                <Route path="messages" element={<PortalAccessGuard><Messages /></PortalAccessGuard>} />
                <Route path="calendar" element={<PortalAccessGuard><PortalCalendar /></PortalAccessGuard>} />
                <Route path="bookonsite" element={<PortalAccessGuard><BookOnSite /></PortalAccessGuard>} />
                <Route path="bookcqc" element={<PortalAccessGuard><BookCQC /></PortalAccessGuard>} />
                <Route path="my-questions" element={<PortalAccessGuard><MyQuestionsPage /></PortalAccessGuard>} />
                <Route path="question/:questionId" element={<PortalAccessGuard><PortalQuestionDetail /></PortalAccessGuard>} />
                <Route path="new-question" element={<Navigate to="/portal/my-questions" replace />} />

                <Route path="lead-phase" element={<Navigate to="/portal" replace />} />
                <Route path="assessmentcycle" element={<Navigate to="/portal" replace />} />
                <Route path="discovery" element={<Navigate to="/portal" replace />} />
                <Route path="lead/self-config" element={<Navigate to="/portal" replace />} />
                <Route path="operations" element={<PortalAccessGuard><PortalOperations /></PortalAccessGuard>}>
                  <Route index element={<Navigate to="all" replace />} />
                  <Route path="all" element={<OperationsAllTab />} />
                  <Route path="sops" element={<SOPs embedded />} />
                  <Route path="kpis" element={<PortalKPIs embedded />} />
                  <Route path="job-descriptions" element={<JobDescriptions embedded />} />
                  <Route path="materials" element={<OperationsMaterialsTab />} />
                  <Route path="org-chart" element={<OrgChart embedded />} />
                </Route>
                <Route path="jobtread" element={<PortalAccessGuard><PortalJobTread /></PortalAccessGuard>} />
                <Route path="hr" element={<PortalAccessGuard><PortalHR /></PortalAccessGuard>}>
                  <Route index element={<HRIndexRedirect />} />
                  <Route path="all" element={<HRAllTab />} />
                  <Route path="materials" element={<HRMaterialsTab />} />
                  <Route path="hiring" element={<HRHiring embedded />} />
                  <Route path="company-direction" element={<CompanyDirection embedded />} />
                </Route>
                <Route path="kpis" element={<PortalAccessGuard><PortalKPIs /></PortalAccessGuard>} />

                <Route path="my-mission-vision-values" element={<PortalAccessGuard><MyMissionVisionValues /></PortalAccessGuard>} />
                <Route path="goals" element={<PortalAccessGuard><Goals /></PortalAccessGuard>} />
                <Route path="operations/goals" element={<PortalAccessGuard><Goals /></PortalAccessGuard>} />
                <Route path="hr/goals" element={<PortalAccessGuard><Goals /></PortalAccessGuard>} />
                <Route path="sales" element={<PortalAccessGuard><PortalSales /></PortalAccessGuard>}>
                  <Route index element={<SalesAllTab />} />
                  <Route path="all" element={<Navigate to="/portal/sales" replace />} />
                  <Route path="awards" element={<Navigate to="/portal/sales" replace />} />
                  <Route path="analytics" element={<SalesAnalyticsTab />} />
                  <Route path="resources" element={<SalesResourcesTab />} />
                  <Route path="goals" element={<SalesGoalsTab />} />
                  <Route path="close-ratio" element={<Navigate to="/portal/sales/analytics" replace />} />
                  <Route path="project-runway" element={<Navigate to="/portal/sales/analytics" replace />} />
                  <Route path="proposals" element={<PortalSalesProposals embedded />} />
                  <Route path="referral-programs" element={<Navigate to="/portal/sales" replace />} />
                  <Route path="sales-scripts" element={<Navigate to="/portal/sales" replace />} />
                  <Route path="design-pricing" element={<DesignPricing embedded />} />
                  <Route path="build-payment-calculator" element={<BuildPaymentCalculator embedded />} />
                  <Route path="pardon-our-dust" element={<Navigate to="/portal/sales" replace />} />
                  <Route path="homeowners-guide" element={<Navigate to="/portal/sales" replace />} />
                </Route>
                <Route path="sales-proposals" element={<Navigate to="/portal/sales/proposals" replace />} />
                <Route path="sales-referral-programs" element={<Navigate to="/portal/sales" replace />} />
                <Route path="sales-pardon-our-dust" element={<Navigate to="/portal/sales" replace />} />
                <Route path="sales-scripts" element={<Navigate to="/portal/sales" replace />} />
                <Route path="sales-awards" element={<Navigate to="/portal/sales" replace />} />
                <Route path="portal-calendar" element={<PortalAccessGuard><PortalCalendar /></PortalAccessGuard>} />
                <Route path="conference" element={<PortalAccessGuard><PortalConference /></PortalAccessGuard>} />
                <Route path="job-descriptions" element={<PortalAccessGuard><JobDescriptions /></PortalAccessGuard>} />
                <Route path="sops" element={<PortalAccessGuard><SOPs /></PortalAccessGuard>} />
                <Route path="technology" element={<PortalAccessGuard><Technology /></PortalAccessGuard>}>
                  <Route index element={<Navigate to="all" replace />} />
                  <Route path="all" element={<TechnologyAllTab />} />
                  <Route path="goals" element={<TechnologyGoalsTab />} />
                  <Route path="calculators" element={<Navigate to="/portal/marketing/calculators" replace />} />
                  <Route path="tech-stack" element={<TechStackVisualizer embedded />} />
                  <Route path="automation" element={<Automation embedded />} />
                  <Route path="receptionist" element={<Receptionist embedded />} />
                  <Route path="estimating-template" element={<Navigate to="/portal/technology/jobtread-imports?type=cost-groups" replace />} />
                  <Route path="chatbot" element={<Chatbot embedded />} />
                  <Route path="jtformulas" element={<JobTreadFormulas embedded />} />
                  <Route path="jobtread-imports" element={<JobTreadImports embedded />} />
                  <Route path="cost-groups" element={<Navigate to="/portal/technology/jobtread-imports?type=cost-groups" replace />} />
                  <Route path="schedules" element={<Navigate to="/portal/technology/jobtread-imports?type=schedules" replace />} />
                  <Route path="dashboards" element={<Navigate to="/portal/technology/jobtread-imports?type=dashboards" replace />} />
                  <Route path="todos" element={<Navigate to="/portal/technology/jobtread-imports?type=todos" replace />} />
                  <Route path="workflows" element={<Workflows embedded />} />
                  <Route path="claude-skills" element={<ClaudeSkills embedded />} />
                  <Route path="agents" element={<Agents embedded />} />
                  <Route path="all-software" element={<AllSoftware embedded />} />
                  <Route path="software/:tier/:typeId/:softwareId" element={<SoftwareOverview embedded />} />
                </Route>
                <Route path="automation/:id" element={<PortalAccessGuard><AutomationOverview /></PortalAccessGuard>} />
                <Route path="finance" element={<PortalAccessGuard><Finance /></PortalAccessGuard>}>
                  <Route index element={<Navigate to="all" replace />} />
                  <Route path="all" element={<FinanceAllTab />} />
                  <Route path="materials" element={<FinanceMaterialsTab />} />
                  <Route path="analytics" element={<FinanceAnalyticsTab />} />
                  <Route path="goals" element={<FinanceGoalsTab />} />
                  <Route path="margin" element={<MarginCalculator embedded />} />
                  <Route path="forecast" element={<Navigate to="/portal/finance/all" replace />} />
                  <Route path="health" element={<Navigate to="/portal/finance/all" replace />} />
                  <Route path="overhead-calculator" element={<OverheadCalculator embedded />} />
                  <Route path="labor-burden" element={<LaborBurdenCalculator embedded />} />
                  <Route path="metrics" element={<Navigate to="/portal/finance/all" replace />} />
                </Route>
                <Route path="marketing" element={<PortalAccessGuard><Marketing /></PortalAccessGuard>}>
                  <Route index element={<Navigate to="all" replace />} />
                  <Route path="all" element={<MarketingAllTab />} />
                  <Route path="analytics" element={<MarketingAnalyticsTab />} />
                  <Route path="goals" element={<MarketingGoalsTab />} />
                  <Route path="website" element={<Website embedded />} />
                  <Route path="social-media" element={<Navigate to="/portal/marketing/analytics" replace />} />
                  <Route path="paid-media" element={<Navigate to="/portal/marketing/analytics" replace />} />
                  <Route path="newsletter" element={<Navigate to="/portal/marketing/analytics" replace />} />
                  <Route path="reviews" element={<ReviewsDashboard embedded />} />
                  <Route path="calculators" element={<WebsiteCalculators embedded />} />
                  <Route path="leads-calculator" element={<LeadsCalculator embedded />} />
                  <Route path="leads-roi" element={<Navigate to="/portal/marketing/analytics" replace />} />
                  <Route path="lead-roi" element={<LeadROI embedded />} />
                  <Route path="leadsmarketing" element={<Navigate to="/portal/marketing/analytics" replace />} />
                  <Route path="strategy" element={<Strategy embedded />} />
                </Route>
                <Route path="courses" element={<PortalAccessGuard><CourseDashboard /></PortalAccessGuard>} />
                <Route path="community" element={<PortalAccessGuard><Community /></PortalAccessGuard>} />
                <Route path="whats-new" element={<Navigate to="/portal" replace />} />
                {/* Category Routes */}
                {/* Course Routes */}
                <Route path="courses/:courseId" element={<PortalAccessGuard><CourseContent /></PortalAccessGuard>} />
                <Route path="courses/:courseId/modules/:moduleId/lessons/:lessonId" element={<PortalAccessGuard><CourseContent /></PortalAccessGuard>} />
                <Route path="takeoffs" element={<PortalAccessGuard><TakeoffProjects /></PortalAccessGuard>} />
                <Route path="proposal" element={<PortalAccessGuard><RoadmapBuilder /></PortalAccessGuard>} />
                <Route path="checkout" element={<PortalAccessGuard><Checkout /></PortalAccessGuard>} />
                <Route path="checkout/return" element={<PortalAccessGuard><CheckoutReturn /></PortalAccessGuard>} />
                <Route path="checkout/strategy-calls/return" element={<PortalAccessGuard><StrategyCallCheckoutReturn /></PortalAccessGuard>} />
                <Route path="contract-complete" element={<PortalAccessGuard><ContractSigningReturn /></PortalAccessGuard>} />
                <Route path="bid-contract-complete" element={<PortalAccessGuard><BidContractSigningReturn /></PortalAccessGuard>} />
                <Route path="roadmap" element={<PortalAccessGuard><Roadmap /></PortalAccessGuard>} />
                <Route path="my-mission-vision-values" element={<PortalAccessGuard><MyMissionVisionValues /></PortalAccessGuard>} />
                <Route path="org-chart" element={<PortalAccessGuard><OrgChart /></PortalAccessGuard>} />
                <Route path="proposed-org-chart" element={<PortalAccessGuard><ProposedOrgChart /></PortalAccessGuard>} />
                <Route path="inventory" element={<Navigate to="/portal" replace />} />
                <Route path="collection" element={<PortalAccessGuard><Collection /></PortalAccessGuard>} />
                <Route path="billing" element={<PortalAccessGuard><BillingPage /></PortalAccessGuard>} />
                <Route path="programs" element={<Navigate to="/portal/billing" replace />} />
                <Route path="programdetail" element={<PortalAccessGuard><ProgramDetail /></PortalAccessGuard>} />
                <Route path="customprogram" element={<PortalAccessGuard><ProgramDetail selectedProgramProp={CUSTOM_PROGRAM} selectedTierProp={CUSTOM_TIER} /></PortalAccessGuard>} />
                <Route path="alacarte" element={<PortalAccessGuard><Navigate to="/portal/billing#portal-plan" replace /></PortalAccessGuard>} />
                <Route path="contract" element={<PortalAccessGuard><PortalContract /></PortalAccessGuard>} />
                {/* Portal HR Routes — the HR hub (/portal/hr) is a tabbed page (all ·
                    materials · hiring · company-direction); these full pages remain
                    reachable by URL for deep links and detail views. */}
                <Route path="hr/hiring/position/:positionId" element={<PortalAccessGuard><PositionHiringOverview /></PortalAccessGuard>} />
                <Route path="hr/onboarding" element={<PortalAccessGuard><Onboarding /></PortalAccessGuard>} />
                <Route path="hr/company-policy" element={<PortalAccessGuard><CompanyPolicy /></PortalAccessGuard>} />
                <Route path="hr/job-listings" element={<PortalAccessGuard><JobListings /></PortalAccessGuard>} />
                <Route path="hr/interview-evaluation" element={<PortalAccessGuard><InterviewEvaluation /></PortalAccessGuard>} />
                <Route path="hr/my-mission-vision-values" element={<PortalAccessGuard><MyMissionVisionValues /></PortalAccessGuard>} />
                <Route path="hr/employee-materials" element={<PortalAccessGuard><EmployeeMaterials /></PortalAccessGuard>} />
                <Route path="crmtechstack" element={<PortalAccessGuard><CRMtechstack /></PortalAccessGuard>} />
                <Route path="summit" element={<PortalAccessGuard><BBASummit /></PortalAccessGuard>} />
              </Route>

              {/* Start Routes — auth required (in dev and prod), same as /crm / /portal */}
              <Route path="/start" element={
                <RoleBasedRoute startAppShell>
                  <SidebarProvider>
                    <div className="app-container">
                      <StartSidebar />
                      <MainContent>
                        <div className="page-content">
                          <StartLayout />
                        </div>
                      </MainContent>
                    </div>
                  </SidebarProvider>
                </RoleBasedRoute>
              }>
                <Route index element={<StartDashboard />} />
                <Route path="dashboard" element={<StartDashboard />} />
                <Route path="assessment" element={<StartAssessment />} />
                <Route path="courses" element={<StartCourses />} />
                <Route path="community" element={<StartCommunity />} />
                <Route path="roadmap" element={<StartRoadmap />} />
                <Route path="sales" element={<StartSales />} />
                <Route path="sales/close-ratio" element={<StartCloseRatio />} />
                <Route path="sales/proposals" element={<StartProposals />} />
                <Route path="sales/resources" element={<StartSalesMaterials />} />
                <Route path="sales-proposals" element={<Navigate to="/start/sales/proposals" replace />} />
                <Route path="finance/labor-burden" element={<Navigate to="/start/finance/startlaborburden" replace />} />
                <Route path="operations/org-chart" element={<Navigate to="/start/existing-org-chart" replace />} />
                <Route path="salesrevenue" element={<SalesRevenue />} />
                <Route path="operations" element={<StartOperations />} />
                <Route path="operations/sops" element={<StartSOPs />} />
                <Route path="operations/kpis" element={<StartKPIs />} />
                <Route path="operations/job-descriptions" element={<StartJobDescriptions />} />
                <Route path="sales-referral-programs" element={<StartPartnerPrograms />} />
                <Route path="technology/estimating-template" element={<StartEstimatingTemplate />} />
                <Route path="technology/chatgpt" element={<StartGPTs />} />
                <Route path="technology/crmtechstack" element={<StartTechStack />} />
                <Route path="operations/gpmoperations" element={<GPMOperations />} />
                <Route path="existing-org-chart" element={<ExistingOrgChart />} />
                <Route path="technology" element={<StartTechnology />} />
                <Route path="technology/crmtechstack" element={<CRMtechstack />} />
                <Route path="finance" element={<StartFinance />} />
                <Route path="finance/startlaborburden" element={<StartLaborBurden />} />
                <Route path="marketing" element={<StartMarketing />} />
                <Route path="marketing/leadsmarketing" element={<Navigate to="/start/marketing" replace />} />
                <Route path="hr" element={<StartHR />} />
                <Route path="profile" element={<StartProfile />} />
                <Route path="nda" element={
                  <OnboardingWrapper currentStep="nda">
                    <NDASigningPage />
                  </OnboardingWrapper>
                } />
                <Route path="nda-complete" element={
                  <OnboardingWrapper currentStep="nda">
                    <NdaSigningReturn />
                  </OnboardingWrapper>
                } />
                <Route path="contract-complete" element={<ContractSigningReturn />} />
                <Route path="discovery" element={<Discovery />} />
                <Route path="existing-conditions" element={<ExistingConditions />} />
                <Route path="existing-direction" element={<ExistingDirection />} />
                <Route path="self-selection" element={<Navigate to="/start/dashboard" replace />} />
                <Route path="solutions" element={<Solutions />} />
                <Route path="proposal" element={<RoadmapBuilder />} />
                <Route path="program" element={<ProgramDetail />} />
                <Route path="programdetail" element={<ProgramDetail />} />
                <Route path="customprogram" element={<ProgramDetail selectedProgramProp={CUSTOM_PROGRAM} selectedTierProp={CUSTOM_TIER} />} />
                <Route path="program-call" element={<ProgramCall />} />
                <Route path="checkout" element={<Checkout />} />
                <Route path="checkout/return" element={<CheckoutReturn />} />
                <Route path="checkout/strategy-calls/return" element={<StrategyCallCheckoutReturn />} />
                <Route path="contract" element={<Contract />} />
                <Route path="alacarte" element={<AlaCarte />} />
                <Route path="hourly" element={<StartHourly />} />
                <Route path="team" element={<StartMeetTheTeam />} />
                <Route path="success-stories" element={<StartSuccessStories />} />
                <Route path="cqc-home" element={<StartCQCHome />} />
                <Route path="process" element={<StartProcess />} />
                <Route path="breakthrough-session" element={<StartBreakthroughSession />} />
                <Route path="assessment-analysis/:leadId" element={<AssessmentAnalysisOverview />} />
              </Route>

              {/* Catch-all route - redirect any undefined routes to login */}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
            
            {/* Survey Popup */}
            <SurveyPopupWrapper />

            </AuthErrorBoundary>
              </Router>
            </SurveyProvider>
          </OnboardingProvider>
        </ResponsiveProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
